module.exports = __webpack_public_path__ + "media/gi bleeding.403f8b41.wav";